// Créer une conversation à plusieurs.
//
// Deux personnes au minimum en plus de soi : à deux, c'est un tête-à-tête, et
// il existe déjà — ouvrir un « groupe » de deux ferait deux conversations avec
// la même personne, dont l'une resterait vide.
//
// Le nom est facultatif. Sans nom, la conversation s'appelle par ses membres,
// exactement comme sur Messenger : « Grâce, Josué et vous ».

import Store from "../store.js";
import { esc, avatar, toast, modale, fermerModale } from "../ui.js";

export function creerConversation(ctx, apres) {
  const choisis = new Map(); // uid -> membre

  const { el } = modale({
    titre: "Nouvelle conversation",
    corps: `
      <label class="label">Nom du groupe (facultatif)
        <input class="champ" id="cv-nom" maxlength="60" placeholder="Ex : Responsables jeunesse">
      </label>
      <div id="cv-choisis" class="filtres" style="margin-bottom:10px"></div>
      <input class="champ" id="cv-q" type="search" placeholder="Rechercher un membre…" autocomplete="off">
      <div class="menu-liste" id="cv-liste" style="margin-top:10px">Chargement…</div>`,
    actions: [
      { label: "Annuler" },
      {
        label: "Créer la conversation",
        classe: "btn--primaire",
        onClick: async (fond, fermer) => {
          if (choisis.size < 2) return toast("Choisissez au moins deux personnes", "erreur");
          const nom = fond.querySelector("#cv-nom").value.trim();
          fermer();
          try {
            const id = await Store.convos.creerGroupe([...choisis.keys()], nom);
            apres ? apres(id) : (location.hash = `#/messages/${id}`);
          } catch (e) {
            toast(e.message || "Création impossible", "erreur");
          }
        },
      },
    ],
  });

  const zone = el.querySelector("#cv-liste");
  const champ = el.querySelector("#cv-q");
  const bandeau = el.querySelector("#cv-choisis");

  // Les personnes retenues restent visibles en haut : sans cela, on cherche
  // quelqu'un, la liste change, et l'on ne sait plus qui l'on a déjà pris.
  const dessinerChoisis = () => {
    bandeau.innerHTML = [...choisis.values()]
      .map((u) => `<button class="chip est-actif" data-retirer="${esc(u.uid)}">${esc(u.nom)} ✕</button>`)
      .join("");
  };

  const peupler = async () => {
    const membres = (await Store.users.search(champ.value)).filter((u) => u.uid !== ctx.moi.uid).slice(0, 20);
    zone.innerHTML = membres.length
      ? membres
          .map(
            (u) => `<button class="menu-item${choisis.has(u.uid) ? " est-actif" : ""}" data-uid="${esc(u.uid)}">
                      ${avatar(u, 34)} ${esc(u.nom)}${choisis.has(u.uid) ? " ✓" : ""}
                    </button>`
          )
          .join("")
      : `<p class="texte-doux petit">Aucun membre trouvé.</p>`;
  };

  champ.addEventListener("input", peupler);

  zone.addEventListener("click", async (e) => {
    const b = e.target.closest("[data-uid]");
    if (!b) return;
    const id = b.dataset.uid;
    if (choisis.has(id)) choisis.delete(id);
    else choisis.set(id, await Store.users.get(id));
    dessinerChoisis();
    peupler();
  });

  bandeau.addEventListener("click", (e) => {
    const b = e.target.closest("[data-retirer]");
    if (!b) return;
    choisis.delete(b.dataset.retirer);
    dessinerChoisis();
    peupler();
  });

  peupler();
  champ.focus();
}
